module.exports = __webpack_public_path__ + "img/successApply.650cda18.png";